export default class City {
    constructor(data) {
        this.id = data.id;
        this.name = data.city;
        this.taken = data.taken;
    }
}